import React from 'react';
import Cliente from '../../components/cliente/Cliente';
import Layout from '../../components/layout/Layout';

const ClientePage = () => {
    return ( <Layout children={<Cliente />} /> )
}

export default ClientePage